import { Inject, Injectable } from '@angular/core';
import { AUTOMATION_NAMESPACE_INJECTION_TOKEN$ } from '@galaxy/automata/shared';
import { map, Observable, of, take } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import {
  AutomationReplacementChipsDataService,
  PagedResponse,
} from '../common/components/automation-replacement-chips/interfaces';
import { AccountGroupSdkService, AggregationSupportedFields } from '@vendasta/account-group';

@Injectable({ providedIn: 'root' })
export class AccountGroupTagsSelectorService implements AutomationReplacementChipsDataService<string> {
  supportsSearching = true;

  constructor(
    private readonly accountGroupService: AccountGroupSdkService,
    @Inject(AUTOMATION_NAMESPACE_INJECTION_TOKEN$) public readonly namespace$: Observable<string>,
  ) {}

  doLookup(searchTerm: string, _cursor: string, _pageSize: number): Observable<PagedResponse<string>> {
    return this.namespace$.pipe(
      switchMap((namespace) =>
        this.accountGroupService.listOptionsForField({
          partnerId: namespace,
          field: AggregationSupportedFields.AGGREGATION_TAGS,
        }),
      ),
      take(1),
      map((resp) => {
        if (searchTerm) {
          resp = resp.filter((tag) => tag.toLowerCase().includes(searchTerm.toLowerCase()));
        }
        return {
          results: resp,
          hasMore: false,
          nextCursor: '',
        };
      }),
    );
  }

  convertDataToDisplay(s: string): Observable<string> {
    return of(s);
  }

  convertDataToFormValue(x: string): any {
    return x;
  }

  getMulti(x: string[]): Observable<string[]> {
    return of(x);
  }
}
